'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import searchIcon from '@public/images/searchWhite.svg';
import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNavV6 } from '@src/components/TopNavV6/TopNavV6Context';
import type { TopNavV6SubNavItem } from '@src/components/TopNavV6/TopNavV6Props';
import { cn } from '@src/utils/tailwind';
import { TopNavV6DesktopMiniMenu } from './TopNavV6DesktopMiniMenu';
import { TopNavV6DesktopThirdLevelMenu } from './TopNavV6DesktopThirdLevelMenu';
interface TopNavV6DesktopSubNavProps {
  items: TopNavV6SubNavItem[];
  showSearch?: boolean;
  onSearchClick?: () => void;
}
export const TopNavV6DesktopSubNav = t0 => {
  const $ = _c(22);
  const {
    items,
    showSearch,
    onSearchClick
  } = t0;
  const {
    setSearchOpen
  } = useTopNavV6();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const leaveTimeoutRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== onSearchClick || $[3] !== setSearchOpen) {
    t3 = () => {
      setSearchOpen(true);
      onSearchClick?.();
    };
    $[2] = onSearchClick;
    $[3] = setSearchOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleSearchClick = t3;
  if (items.length === 0) {
    return null;
  }
  const hoveredItem = hoveredIndex !== null ? items[hoveredIndex] : null;
  const thirdLevelMenu = hoveredItem?.navItems;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      leaveTimeoutRef.current = setTimeout(() => {
        setHoveredIndex(null);
      }, 100);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleSearchClick || $[7] !== showSearch) {
    t5 = showSearch && <button aria-label="Search" onClick={handleSearchClick} className="flex items-center justify-center"><Image src={searchIcon} width={20} height={20} alt="Search" /></button>;
    $[6] = handleSearchClick;
    $[7] = showSearch;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== hoveredIndex || $[10] !== items) {
    t6 = items.map((item, index) => <div key={`sub-nav-item-${index}`} className="relative" onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => {
      if (!item.navItems && !item.miniMenu) {
        setHoveredIndex(null);
      }
    }}><LocalizedLink href={item.href ?? "#"} onClick={item.onClick} className={cn("group flex h-full items-center justify-center border-0 border-solid border-bodi-gray-light px-0 py-4 transition-colors hover:underline", {
        "text-bodi-white hover:decoration-bodi-white": hoveredIndex === index,
        "text-bodi-gray-butters hover:decoration-bodi-white": hoveredIndex !== index
      })}><span className="font-sans text-body-base leading-6 font-normal">{item.title}</span>{(item.navItems ?? item.miniMenu) && <div className="flex h-6 w-6 shrink-0 items-center justify-center"><ChevronDownIcon className="size-5" /></div>}</LocalizedLink>{item.miniMenu && hoveredIndex === index && <div onMouseEnter={() => {
        if (leaveTimeoutRef.current) {
          clearTimeout(leaveTimeoutRef.current);
          leaveTimeoutRef.current = null;
        }
      }} onMouseLeave={() => {
        if (leaveTimeoutRef.current) {
          clearTimeout(leaveTimeoutRef.current);
          leaveTimeoutRef.current = null;
        }
        setHoveredIndex(null);
      }}><TopNavV6DesktopMiniMenu menu={item.miniMenu} isVisible={hoveredIndex === index} /></div>}</div>);
    $[9] = hoveredIndex;
    $[10] = items;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="relative z-40 mx-auto w-full max-w-420 bg-bodi-black-text py-0" onMouseLeave={t4}><div className="flex h-12 items-center gap-6">{t5}{t6}</div></div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== hoveredIndex || $[16] !== hoveredItem || $[17] !== thirdLevelMenu) {
    t8 = thirdLevelMenu && <div onMouseEnter={() => {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
        leaveTimeoutRef.current = null;
      }
    }} onMouseLeave={() => {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
        leaveTimeoutRef.current = null;
      }
      setHoveredIndex(null);
    }}><TopNavV6DesktopThirdLevelMenu menu={thirdLevelMenu} subNavItem={hoveredItem} isVisible={hoveredIndex !== null} /></div>;
    $[15] = hoveredIndex;
    $[16] = hoveredItem;
    $[17] = thirdLevelMenu;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className="relative border-b border-bodi-gray-dark bg-bodi-black-text px-4">{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};